import { render, staticRenderFns } from "./item_prop.vue?vue&type=template&id=3b45cd22&scoped=true"
import script from "./item_prop.vue?vue&type=script&lang=ts"
export * from "./item_prop.vue?vue&type=script&lang=ts"
import style0 from "./item_prop.vue?vue&type=style&index=0&id=3b45cd22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b45cd22",
  null
  
)

export default component.exports